import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/smarthomepanel/pc/');

export default function Comp({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.gsapA2} gsapA2`}>
            <div className="item-box item-box1">
                <div className="item-box-img">
                    <EFPic
                        name={["img_8.webp", "img_8.jpg"]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('Smart Home Panel')}
                    />
                </div>
                <div className="msg-box">
                    <div className="msg-line1">{t('smart_home_panel.ytdd_sec1_tit')}</div>
                    <div className="msg-line2">{t('smart_home_panel.ytdd_sec1_subtit')}</div>
                </div>
            </div>
            <div className="item-box item-box2">
                <div className="item-box-img">
                    <EFPic
                        name={["img_9_new.webp", "img_9_new.jpg"]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('Smart Home Panel')}
                    />
                </div>
                <div className="msg-box">
                    {t('smart_home_panel.ytdd_sec4_tit_pc1')}
                    <br />
                    {t('smart_home_panel.ytdd_sec4_tit_pc2')}
                </div>
            </div>
            <div className="item-box item-box3">
                <div className="item-box-img">
                    <EFPic
                        name={["img_0.webp", "img_0.jpg"]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('Smart Home Panel')}
                    />
                </div>
                <div className="msg-box">
                    {t('smart_home_panel.ytdd_sec2-sec1_tit_pc1')}
                    <br />
                    {t('smart_home_panel.ytdd_sec2-sec1_tit_pc2')}
                </div>
            </div>
            <div className="item-box item-box4">
                <div className="item-box-img">
                    <EFPic
                        name={["img_6.webp", "img_6.jpg"]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('Smart Home Panel')}
                    />
                </div>
                <div className="msg-box">
                    <div className="msg-line1">{t('smart_home_panel.ytdd_sec3_tit')}</div>
                </div>
            </div>
            <div className="item-box item-box5">
                <div className="item-box-img">
                    <EFPic
                        name={locale === 'jp' ? ["img_7_jp.webp", "img_7_jp.jpg"] : ["img_7_en.webp", "img_7_en.jpg"]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('Smart Home Panel')}
                    />
                </div>
                <div className="msg-box">
                    <div className="msg-line1">{t('smart_home_panel.ytdd_sec5_tit')}</div>
                    <div className="msg-line2">{t('smart_home_panel.ytdd_sec5_subtit')}</div>
                </div>
            </div>
            <div className="item-box item-box6">
                <div className="item-box-img">
                    <EFPic
                        name={["img_5.webp", "img_5.jpg"]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('Smart Home Panel')}
                    />
                </div>
                <div className="msg-box">{t('smart_home_panel.ytdd_sec2-sec2_tit')}</div>
            </div>
        </div>
    );
}
